import React from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';

import List from './List';
import Edit from './Edit';

const Routes = () => (
  <Switch>
    <Route exact path="/manage/settings" component={List} />
    <Route exact path={`/manage/settings/:settingId/edit`} component={Edit} />
    <Redirect to="/manage/settings" />
  </Switch>
);
export default Routes;
